import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { getKeyHandler } from '../structure/FlowForm';
import './FocusText.css';
const FocusText = ({ children, focusId, onClick, onFocus, onBlur, focusVisible = true, focussable = 'flow', underline = false, className = '', keyOverride, keyHandler }) => {
    const [clicked, setClicked] = React.useState(false);
    const click = () => {
        setClicked(true);
        setTimeout(() => setClicked(false), 200);
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    const handleKeyDown = getKeyHandler({
        enterBehaviour: 'action',
        spaceBehaviour: 'action',
        sidewaysBehaviour: focussable == 'flow2d' ? '2d' : 'both',
        onAction: () => click(),
        overrideHandlers: keyOverride,
        defaultHandler: keyHandler,
    });
    return (_jsx("span", { id: focusId, className: `focusText ${className !== null && className !== void 0 ? className : ''} ${underline ? 'underlined ' : ''}${focussable == 'flow' ? 'flowFocussable' : focussable == 'sideway' ? 'flowFocussable sidewayFocus' : focussable == 'flow2d' ? 'flowFocussable flow2d' : ''} ${clicked ? 'clicked' : 'unclicked'}${focusVisible ? '' : ' focusInvisible'}`, tabIndex: 0, onClick: (ev) => { ev.preventDefault(); ev.stopPropagation(); click(); }, onFocus: onFocus, onBlur: () => { return onBlur === null || onBlur === void 0 ? void 0 : onBlur(); }, onKeyDown: handleKeyDown, children: children }));
};
export default FocusText;
